import { SESSION_STORAGE_KEYS } from 'constants/defaultValues';
import { liveChatStatusMapping } from 'constants/userStatus';
import AuthContext from 'contexts/auth/context';
import { useContext, useState } from 'react';
import { changeLivechatStatus } from 'services/changeLivechatStatus';
import { getLivechatUserInfo } from 'services/getLivechatUserInfo';
import { logError } from 'services/Logger';
import { setUserStatus } from 'services/setUserStatus';
import { UserStatus } from 'types/user';
import { persistInLocalStorage } from 'utils/localStorageUtils';

const useChangeStatus = () => {
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessageKey, setErrorMessageKey] = useState('');
  const userId = sessionStorage.getItem(SESSION_STORAGE_KEYS.USER_ID) || '';
  const [isLoading, setLoading] = useState(false);
  const { changeAgentStatus } = useContext(AuthContext);

  const changeStatus = async (newStatus: string) => {
    try {
      setLoading(true);
      const response = await changeLivechatStatus(liveChatStatusMapping[newStatus]);
      const message = JSON.parse(response.data.message);
      const apiError = message.error;
      if (apiError) {
        setShowErrorModal(true);
        setErrorMessageKey(`rocketChat.${apiError.error}`);
        throw new Error(apiError.message);
      }

      await setUserStatus(newStatus);
      sessionStorage.setItem(SESSION_STORAGE_KEYS.MANUAL_OFFLINE, String(newStatus === UserStatus.Offline));
      persistInLocalStorage(SESSION_STORAGE_KEYS.MANUAL_OFFLINE);
      const { data: livechatInfo } = await getLivechatUserInfo(userId);

      changeAgentStatus({
        status: livechatInfo.user.status,
        statusLivechat: livechatInfo.user.statusLivechat,
      });
    } catch (e) {
      logError((e as Error).message, e);
    }
    setLoading(false);
  };

  return {
    changeStatus,
    showErrorModal,
    setShowErrorModal,
    errorMessageKey,
    setErrorMessageKey,
    isLoading,
  };
};

export default useChangeStatus;
